import { render, staticRenderFns } from "./ActividadesEconomicas.vue?vue&type=template&id=5238f2ac&"
import script from "./ActividadesEconomicas.vue?vue&type=script&lang=js&"
export * from "./ActividadesEconomicas.vue?vue&type=script&lang=js&"
import style0 from "./ActividadesEconomicas.vue?vue&type=style&index=0&id=5238f2ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports